/**
 * Created by jerome on 27/10/2018.
 */
const isIEorEdge = function () {
  const uA = window.navigator.userAgent
  return /msie\s|trident\/|edge\//i.test(uA)
}
export default isIEorEdge